<template>
  <div class="content content--secondary">
    <div class="single-column">
      <section class="single-column__section">
        <h2 class="single-column__heading">アーティスト登録</h2>
        <div class="single-column__inner">
          <div class="profile-edit__head-text">
            <span>アーティストを登録してください。</span>
            <br>あとで記入することも可能です。
            <ul class="c-indent-list">
              <li class="c-indent-list__node">
                アーティスト名は初回リリースの配信手続きが完了するまで変更することができます。
              </li>
              <li class="c-indent-list__node">
                配信手続き完了後～配信期間中は、アーティスト情報の変更を行っても、
                各配信ストアの情報は変更されません。
              </li>
              <li class="c-indent-list__node">
                各配信ストアの規定により表記が変更される場合があります。
                また、変更をお願いする場合があります。
              </li>
            </ul>
          </div>
          <div class="profile-info">
            <form>
              <div class="form-wrap form-wrap--profile u-no-margin-top">
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="artist_name_domestic">アーティスト名
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="artist_name_domestic"
                      v-model="artist_name_domestic"
                      class="form-control"
                      type="text"
                      placeholder="ノンブラリ">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="artist_name_hk">アーティスト名（カナ表記）
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="artist_name_hk"
                      v-model="artist_name_hk"
                      class="form-control"
                      type="text"
                      placeholder="ノンブラリ">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label form-label--top">
                    <label
                      class="control-label"
                      for="artist_name_overseas">アーティスト名（アルファベット表記）
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="artist_name_overseas"
                      v-model="artist_name_overseas"
                      class="form-control"
                      type="text"
                      placeholder="nonbrari">
                    <div class="form-item-text pcmt10 spmt10">
                      アーティストは個別に登録します<br>
                      以下は入力NGです<br>
                      ・ジョン・レノン from ビートルズ[グループ名が含まれる]<br>
                      ・Lee（ギター）[役割が含まれる]
                    </div>
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="url">アーティストページURL
                    </label>
                  </div>
                  <div class="form-item">
                    <span class="pcmr5 spmr5">https://zula.jp/artist/</span>
                    <input
                      id="url"
                      v-model="url"
                      class="form-control form-control--w400"
                      type="text"
                      placeholder="ノンブラリ">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="genre_domestic">ジャンル
                    </label>
                  </div>
                  <div class="form-item">
                    <div class="form-item-inline form-item-inline--sp-reset">
                      <span class="form-item__wrap">
                        <div class="c-select_wrap">
                          <select
                            id="genre_domestic"
                            v-model="genre_domestic"
                            class="form-control c-select">
                            <option
                              value=""
                              disabled
                              selected
                              style="display:none;">選択してください
                            </option>
                            <option value="1">J-POP</option>
                            <option value="2">ロック</option>
                            <option value="3">オルタナティブ</option>
                            <option value="4">ブルース</option>
                            <option value="5">アニメ</option>
                            <option value="6">クラシック</option>
                            <option value="7">ダンス</option>
                            <option value="8">エレクトロニック</option>
                            <option value="9">演歌/日本伝統</option>
                            <option value="10">フォーク</option>
                            <option value="11">ハウス</option>
                            <option value="12">カラオケ</option>
                            <option value="13">歌謡曲</option>
                            <option value="14">レゲエ</option>
                            <option value="15">R&B</option>
                            <option value="16">Soul</option>
                            <option value="17">テクノ</option>
                            <option value="18">ジャズ</option>
                            <option value="19">ワールド</option>
                            <option value="20">ヒップホップ</option>
                            <option value="21">ラップ</option>
                            <option value="22">Vocal</option>
                            <option value="23">サウンドトラック</option>
                            <option value="24">Easy Listening</option>
                            <option value="25">キッズ</option>
                            <option value="26">ボサノバ</option>
                          </select>
                        </div></span>
                      <p class="error-text">〇〇が選択されていません</p>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="genre_overseas">ジャンル（アルファベット表記）
                    </label>
                  </div>
                  <div class="form-item">
                    <div class="form-item-inline form-item-inline--sp-reset">
                      <span class="form-item__wrap">
                        <div class="c-select_wrap">
                          <select
                            id="genre_overseas"
                            v-model="genre_overseas"
                            class="form-control c-select">
                            <option
                              value=""
                              disabled
                              selected
                              style="display:none;">選択してください
                            </option>
                            <option value="1">J-POP</option>
                            <option value="2">ロック</option>
                            <option value="3">オルタナティブ</option>
                            <option value="4">ブルース</option>
                            <option value="5">アニメ</option>
                            <option value="6">クラシック</option>
                            <option value="7">ダンス</option>
                            <option value="8">エレクトロニック</option>
                            <option value="9">演歌/日本伝統</option>
                            <option value="10">フォーク</option>
                            <option value="11">ハウス</option>
                            <option value="12">カラオケ</option>
                            <option value="13">歌謡曲</option>
                            <option value="14">レゲエ</option>
                            <option value="15">R&B</option>
                            <option value="16">Soul</option>
                            <option value="17">テクノ</option>
                            <option value="18">ジャズ</option>
                            <option value="19">ワールド</option>
                            <option value="20">ヒップホップ</option>
                            <option value="21">ラップ</option>
                            <option value="22">Vocal</option>
                            <option value="23">サウンドトラック</option>
                            <option value="24">Easy Listening</option>
                            <option value="25">キッズ</option>
                            <option value="26">ボサノバ</option>
                          </select>
                        </div>
                      </span>
                      <p class="error-text">〇〇が選択されていません</p>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="area_domestic">活動エリア
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="area_domestic"
                      v-model="area_domestic"
                      class="form-control form-control--w320"
                      type="text">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="area_overseas">活動エリア（アルファベット表記）
                    </label>
                  </div>
                  <div class="form-item">
                    <div class="form-item"></div>
                    <input
                      id="area_overseas"
                      v-model="area_overseas"
                      class="form-control form-control--w320"
                      type="text">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label form-label--top">
                    <label
                      class="control-label"
                      for="member_name_domestic">メンバー
                    </label>
                  </div>
                  <div class="form-item">
                    <div class="form-item-member">
                      <div class="form-item-member__wrap">
                        <input
                          id="member_name_domestic"
                          v-model="member_name_domestic"
                          class="form-control"
                          type="text"
                          placeholder="名前">
                        <input
                          id="member_name_overseas"
                          v-model="member_name_overseas"
                          class="form-control"
                          type="text"
                          placeholder="名前（アルファベット表記）">
                        <input
                          id="member_role_domestic"
                          v-model="member_role_domestic"
                          class="form-control"
                          type="text"
                          placeholder="役割">
                        <input
                          id="member_role_overseas"
                          v-model="member_role_overseas"
                          class="form-control"
                          type="text"
                          placeholder="役割（アルファベット表記）">
                      </div>
                    </div>
                    <p class="error-text">〇〇が入力されていません</p>
                    <div class="form-group-wrap__btn-wrap form-group-wrap__btn-wrap--nomargin">
                      <button class="c-btn c-btn--narrow">
                        追加
                        <span class="c-btn__icon-add">
                          <span></span>
                        </span>
                      </button>
                      <button class="c-btn c-btn--delete-large c-btn--narrow c-btn--right">
                        削除
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label form-label--top">
                    <label
                      class="control-label"
                      for="profile_domestic">プロフィール
                    </label>
                  </div>
                  <div class="form-item">
                    <textarea
                      id="profile_domestic"
                      v-model="profile_domestic"
                      class="c-textarea">
                    </textarea>
                    <p class="error-text">〇〇を入力してください</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label form-label--top">
                    <label
                      class="control-label"
                      for="profile_overseas">プロフィール（アルファベット表記）
                    </label>
                  </div>
                  <div class="form-item">
                    <textarea
                      id="profile_overseas"
                      v-model="profile_overseas"
                      class="c-textarea">
                    </textarea>
                    <p class="error-text">〇〇を入力してください</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label class="control-label">アーティスト写真</label>
                  </div>
                  <div class="form-item">
                    <a class="c-btn c-btn--download--narrow">
                      ファイルをアップロード
                      <img
                        src="/img/common/icon-download_white.png"
                        alt="">
                    </a>
                    <p class="error-text">〇〇を入力してください</p>
                  </div>
                </div>
              </div>
              <div class="c-btn-wrap">
                <a class="c-btn">内容を確認
                  <span class="c-btn__icon-arrow"></span>
                </a>
                <a class="c-btn c-btn--change c-btn--left">プレビュー
                  <span class="c-btn__icon-arrow"></span>
                </a>
                <a class="c-btn c-btn--back c-btn--right">あとで設定
                  <span class="c-btn__icon-arrow c-btn__icon-arrow--right"></span>
                </a>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddArtist',
  data() {
    return {
      artist_name_domestic: '',
      artist_name_hk: '',
      artist_name_overseas: '',
      url: '',
      genre_domestic: '',
      genre_overseas: '',
      area_domestic: '',
      area_overseas: '',
      member_name_domestic: '',
      member_name_overseas: '',
      member_role_domestic: '',
      member_role_overseas: '',
      profile_domestic: '',
      profile_overseas: '',
    }
  },
}
</script>

<style scoped>

</style>
